import { render, staticRenderFns } from "./ModalStudentData.vue?vue&type=template&id=7dbc322d&scoped=true&lang=pug&"
import script from "./ModalStudentData.vue?vue&type=script&lang=ts&"
export * from "./ModalStudentData.vue?vue&type=script&lang=ts&"
import style0 from "./ModalStudentData.vue?vue&type=style&index=0&id=7dbc322d&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dbc322d",
  null
  
)

export default component.exports